export default __webpack_public_path__ + "static/media/dermatologist.2c36685c.png";